import t from 'tcomb';

//const digitsRegExp = /^\d*$/;

const Mobile = t.String; // t.refinement(t.String, (s) => digitsRegExp.test(s), 'Mobile');

export default Mobile;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Mobile.js
 **/